// HeroSection.js
import React, { useEffect, useState } from 'react';
import { Container, Row, Col, Button } from 'react-bootstrap';
import { Images } from '../../../../assets/assets';
import { Link } from 'react-router-dom';
import './HeroSection.css';
import { useHomeStore } from '../../../../store/useHomeStore';
import Loader from '../../../Loader';


const HeroSection = () => {
  const { banner, getBanner } = useHomeStore()
  const [loading, setLoading] = useState(false)

  const fetchBannerData = async () => {
    setLoading(true)
    await getBanner()
    setLoading(false)
  }

  useEffect(() => {
    if (!banner) {
      fetchBannerData()
    }
  }, [banner, getBanner])

  return (
    <div>
      <Loader loading={loading}>
        <div className="hero-section" style={{
          "--hero-bg": banner?.image ? `url(${banner.image})` : ""
        }}>

          <div className="hero-overlay" />
          <Container className="theme-container">
            <Row className="align-items-center">
              <Col md={7}>
                <div className='hero-content'>
                  <p className="section-subtitle">{banner?.subTitle}</p>
                  <h1 className="section-title">
                    {banner?.title}
                  </h1>
                  <p className="hero-description fs-6">
                    {banner?.description}
                  </p>
                  <div className='hero-btn-holder mt-xl-4 mt-lg-3 mt-2'>
                    <Link to="/contact-us" className="btn hero-btn btn-solid-orange">
                      <span className="fw-bold me-3 ">{banner?.buttonText}</span>
                      <img className="img-fluid" src={Images.FancyCornerIcon} alt="Phone icon" />

                    </Link>
                  </div>
                </div>
              </Col>
            </Row>
          </Container>
        </div>
      </Loader>
    </div>
  );
};

export default HeroSection;
